import React from 'react'
import BaseLevel from './base.levels'
import { BaseLevelLayoutComponent, DotsGridComponent } from '../level.components'
import hundredSquareUtils from './utils/hundredSquare.utils'
import hundredSquareTapUtils from './utils/hundredSquareTap.utils'
import numberUtils from './utils/number.utils'

export default class HundredSquareComponent extends BaseLevel {
    onEnter = () => {
        const answerRequired = this.props.level.settings.answer_required
        let result = 0
        const quantities = this.state.quantities
        if (answerRequired === 'value_1') {
            result = this.state.quantities.value_1
        } else if (answerRequired === 'value_2') {
            result = this.state.quantities.value_2
        } else {
            result = this.state.operation === 'addition' ?
                +this.state.quantities.value_1 + +this.state.quantities.value_2 :
                this.state.quantities.value_1 - this.state.quantities.value_2
        }

        if (+this.state.answer === +result) {
            this.setState({ wrongAnswer: false, answer: '?' })
            this.props.onRoundComplete()
            this.generateLevel()
            this.onRoundComplete()
        } else {
            this.setState({ wrongAnswer: true, answer: '?' })
            this.props.onRoundFail()
            this.onRoundFail()
        }
    }

    onTapEnter = () => {
        this.setState({ wrongAnswer: false, answer: '?' })
        this.props.onRoundComplete()
        this.generateLevel()
        this.onRoundComplete()
    }
    onFail = () => {
        this.setState({ wrongAnswer: true, answer: '?' })
        this.props.onRoundFail()
        this.onRoundFail()
    }

    render() {
        const level = this.props.level
        const stage = this.props.stage
        let settings = level.settings
        const quantities = this.state.quantities
        const answer = this.state.answer
        const wrongAnswer = this.state.wrongAnswer
        const gameContainerWidth = this.state.gameContainerWidth
        const gameContainerHeight = this.state.gameContainerHeight
        const showSum = settings.show_sum
        const answerString = settings.show_sum && settings.operation !== 'tap' ? numberUtils.getNumberString(settings, quantities, answer) : answer
         
        return (
            <BaseLevelLayoutComponent level={level} togglePause={this.props.togglePause} updateDimensions={this.updateDimensions} progress={this.props.progress || 0} stage={stage} answer={answerString} showSum={settings.show_sum} wrongAnswer={wrongAnswer} userBot={this.props.userBot} onRefresh={this.onRefresh} score={this.props.score} flash={this.state.flash} instruction={level.instruction} onExit={this.props.onExit} onUpdate={this.onUpdate} onEnter={this.onEnter}>
                <div ref="level" className='level'>
                    {gameContainerHeight > 0 && settings.operation !== 'tap' && hundredSquareUtils.getLevelLayout(gameContainerWidth, gameContainerHeight, settings, quantities, this.onEnter)}
                    {gameContainerHeight > 0 && settings.operation === 'tap' && hundredSquareTapUtils.getLevelLayout(gameContainerWidth, gameContainerHeight, settings, quantities, this.onTapEnter, this.onFail)}
                </div>
            </BaseLevelLayoutComponent>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/game/levels/hundredSquare.levels.js